import { PropsWithChildren } from 'react';
import { Button } from '../ui/button';
import CTAArrow from '../icons/CTAArrow';
import SpinningIcon from '../icons/SpinningIcon';

export default function InputSubmit({
  disabled,
  className,
  children,
  hasIcon,
  variant,
  size,
  isLoading,
}: PropsWithChildren<{
  disabled?: boolean;
  className?: string;
  hasIcon?: boolean;
  variant?:
    | 'default'
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  uppercase?: boolean;
  isLoading?: boolean;
}>) {
  return (
    <Button
      type="submit"
      disabled={disabled || undefined}
      className={className || undefined}
      variant={variant || undefined}
      size={size || undefined}
    >
      {children}

      {hasIcon && isLoading && <SpinningIcon />}
      {hasIcon && !isLoading && <CTAArrow />}
    </Button>
  );
}
